type ErrorType = 'NOT_LOGGED_IN';

export class Leerkr8Error extends Error {
  public readonly type: ErrorType = 'NOT_LOGGED_IN';

  constructor(message: string, type: ErrorType) {
    super(message);
    this.name = 'Leerk8Error';
    this.type = type;
  }
}
